import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component
class ProfileUpdateModal extends Vue {
  dtRules: any;
  constructor() {
    super();
    this.dtRules = {}
  }
  @Prop({ default: false, type: [ Boolean ] })
  visible: boolean;
  @Prop({ default: false, type: [ Boolean ] })
  loading: boolean;
  @Prop({ default: '', type: String })
  titleModal: string;
  @Prop({ default: '', type: String })
  textModal: string;

  @UserStore.Getter userInfo: { id: number };

  get lblSetting() {
    return {
      ...require('../../../../locales/profile/index').default
    };
  }
  get coModalVisible(): boolean {
    return this.visible;
  }
  set coModalVisible(value: boolean) {
    this.$emit('update:visible', value)
  }

  created() {
    this.dtRules = {}
  }

  @Emit('save')
  handleSave(event) { }
}

export default ProfileUpdateModal;



// WEBPACK FOOTER //
// ./src/containers/profile/components/profile-update-modal/index.ts